import axios from 'axios';
import * as endpoint from '../../../endpoint';
import { consolelog, delCancelToken } from '../../../../lib/tools';
import { createCancelToken, handleErrorResponse } from '../../apis';
import { configureAxiosForJSON } from '../../axiosConfig';

/**
 * アクションログ取得
 *
 * @param {*} apiToken APIトークン
 * @param {*} searchOptions 検索条件
 * @param {*} responseAction レスポンスタイプ
 * @returns APIレスポンス
 */
const getActivityLogs =
  (apiToken, searchOptions, responseAction) => dispatch => {
    consolelog('[API CALL] getActivityLogs()');
    configureAxiosForJSON(apiToken);

    // APIエンドポイント
    const url = endpoint.API_GET_ACTION_LOGS;

    // リクエストパラメータの設定
    const { cancelToken, cancelTokenKey } =
      createCancelToken('getActivityLogs');
    const params = { cancelToken, params: searchOptions };
    return axios
      .get(url, params)
      .then(res => {
        delCancelToken(cancelTokenKey);
        dispatch({
          type: responseAction,
          payload: res.data,
        });
      })
      .catch(thrown => {
        delCancelToken(cancelTokenKey);
        if (!axios.isCancel(thrown)) {
          handleErrorResponse(thrown, dispatch);
        }
      });
  };

export default getActivityLogs;
